import * as React from 'react';
import { login, singUp, whoAmI } from '../../server/server';
import { useNavigate, useLocation } from 'react-router-dom';
import { redirect } from 'react-router-dom';
import { useUser } from '../../auth/UseUser';
import { ReactComponent as BeeLogoNavbar } from '../../assets/svg/BeeLogoNavbar.svg';
import { ReactComponent as ChevronLeft } from '../../assets/svg/ChevronLeft.svg';
import { ReactComponent as ShowPasswordIcon } from '../../assets/svg/ShowPasswordIcon.svg';
import { ReactComponent as HidePasswordIcon } from '../../assets/svg/HidePasswordIcon.svg';
import { ReactComponent as CheckSolid } from '../../assets/svg/CheckSolid.svg';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useState } from 'react';
import { toast } from 'react-hot-toast';
import { notif } from '../utils/util';
import Loading from '../../utils/Loading';

type Inputs = {
    username: string;
    email: string;
    password: string;
    repeatPassword: string;
};
interface SignIn {
    setSelectedMode: any;
}

function Registration({ setSelectedMode }: SignIn) {
    const navigate = useNavigate();
    const { setUser } = useUser();
    const [showPassword, setShowPassword] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const {
        register,
        handleSubmit,
        watch,
        getValues,
        setValue,
        reset,
        trigger,
        formState: { errors, isValid },
    } = useForm<Inputs>({
        defaultValues: {
            username: '',
            email: '',
            password: '',
            repeatPassword: '',
        },
    });

    const onSubmit: SubmitHandler<Inputs> = async () => {
        await signUpUser();
    };

    const toggleShowPassword = () => {
        setShowPassword((prev) => !prev);
    };

    const signUpUser = async () => {
        setLoading(true);
        console.log('registracija data', getValues());
        const resp = await singUp({
            email: getValues('email'),
            password: getValues('password'),
            username: getValues('username'),
        });
        if (resp.status === 201) {
            const data = resp.data;
            setErrorMessage('');
            console.log('registration success', data);
            localStorage.setItem('accessToken', data['accessToken']);
            const response = await whoAmI();
            if (response.status === 200) {
                const whoData = response.data;
                if (whoData.valid === false) {
                    localStorage.removeItem('accessToken');
                    notif(
                        'Poslat vam je email za verifikaciju naloga. Molimo vas proverite vas inbox (pogledajte spam ili junk folder ukoliko nije u inboxu).',
                        'info',
                        55000,
                    );
                    setSelectedMode('login');
                    setLoading(false);
                } else {
                    setLoading(false);
                }
            } else {
                console.log('who am i failed ', response.status);
            }
        } else {
            console.log('registration error', resp?.data);
            setErrorMessage(resp?.data?.message);
        }
        setLoading(false);
    };

    return (
        <div className="w-full bg-white flex flex-col items-center">
            <div className=" flex flex-col max-w-[430px] w-full px-3 mx-auto ">
                <p className="text-[32px] leading-[44px] text-black700  font-bold  ">Registruj se</p>
                <p className="text-[16px] leading-5 text-black700 font-medium mt-[12px] mb-[25px] ">Popunite podatke kako bi ste se registrovali</p>
                <form className="flex flex-col items-center w-full " onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                    <div className="flex flex-col w-full">
                        <label className="text-[16px] leading-5 text-black700 font-bold  ">Email adresa (koristiće se prilikom prijave)</label>
                        <div className=" border border-black200 rounded-[4px] h-[48px] w-full px-3 flex flex-row items-center ">
                            <input
                                className="text-[16px] leading-[22px] text-black700  w-full outline-none  placeholder:text-black200 "
                                placeholder="Email adresa"
                                {...register('email', {
                                    required: true,
                                    pattern: {
                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                        message: 'invalid email address',
                                    },
                                })}
                            />
                        </div>
                        <span className="text-redError text-[12px] leading-5 h-5 ">
                            {errors.email?.type === 'required' ? 'Obavezno popunite ovo polje!' : ''}
                            {errors.email?.type === 'pattern' ? 'Email adresa nije ispravno popunjena!' : ''}
                        </span>
                    </div>
                    <div className="flex flex-col w-full">
                        <label className="text-[16px] leading-5 text-black700 font-bold  ">Korisničko ime (nadimak ili eng. username)</label>
                        <div className=" border border-black200 rounded-[4px] h-[48px] w-full px-3 flex flex-row items-center ">
                            <input
                                className="text-[16px] leading-[22px] text-black700  w-full outline-none  placeholder:text-black200 "
                                placeholder="Ime"
                                {...register('username', {
                                    validate: {
                                        najduze: (value) => value.length < 30,
                                        obavezno: (value) => value.length > 0,
                                    },
                                })}
                            />
                        </div>
                        <p className="text-redError text-[12px] leading-5 h-5 ">
                            <span>{errors.username?.type === 'obavezno' ? 'Obavezno popunite ovo polje!' : ''} </span>
                            <span>{errors.username?.type === 'najduze' ? 'Duzina nesme prelaziti 30 karaktera' : ''}</span>
                        </p>
                    </div>
                    <div className="flex flex-col w-full">
                        <label className="text-[16px] leading-5 text-black700 font-bold  ">Lozinka</label>
                        <div className=" border border-black200 rounded-[4px] h-[48px] w-full px-3 flex flex-row items-center ">
                            <input
                                className="text-[16px] leading-[22px] text-black700  w-full outline-none  placeholder:text-black200 "
                                placeholder="Lozinka"
                                type={showPassword ? 'text' : 'password'}
                                {...register('password', {
                                    required: true,
                                    minLength: 8,
                                    pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d\w\W]{8,}$/,
                                })}
                                autoComplete="off"
                                onChange={(e) => {
                                    setValue('password', e.target.value.toString(), { shouldValidate: true });
                                    if (getValues('repeatPassword') !== '') trigger('repeatPassword');
                                }}
                            />
                            <div className="cursor-pointer" onClick={toggleShowPassword}>
                                {!showPassword ? <ShowPasswordIcon /> : <HidePasswordIcon width={22} height={18} />}
                            </div>
                        </div>
                        <span className="text-redError text-[12px] leading-5 h-5 ">
                            {errors.password?.type === 'required' ? 'Obavezno popunite ovo polje!' : ''}
                            {errors.password?.type === 'minLength' ? 'Šifra treba da ima najmanje 8 karaktera!' : ''}
                            {errors.password?.type === 'pattern' ? 'Šifra treba da ima najmanje 8 karaktera, jedno veliko slovo i jedan broj' : ''}
                        </span>
                        <div className="flex flex-row items-center justify-between h-[30px]">
                            <p className="w-[200px] text-[16px] leading-5 text-black700 ">Jedno veliko slovo</p>
                            {/[A-Z]/.test(watch('password')) && <CheckSolid />}
                        </div>
                        <div className="flex flex-row items-center justify-between h-[30px]">
                            <p className="w-[200px] text-[16px] leading-5 text-black700 ">Jedno malo slovo</p>
                            {/[a-z]/.test(watch('password')) && <CheckSolid />}
                        </div>
                        <div className="flex flex-row items-center justify-between h-[30px]">
                            <p className="w-[200px] text-[16px] leading-5 text-black700 ">Jedan broj</p>
                            {/[0-9]/.test(watch('password')) && <CheckSolid />}
                        </div>
                        <div className="flex flex-row items-center justify-between h-[30px]">
                            <p className="w-[200px] text-[16px] leading-5 text-black700 ">Najmanje 8 karaktera</p>
                            {watch('password').length > 7 && <CheckSolid />}
                        </div>
                    </div>
                    <div className="flex flex-col w-full mt-5">
                        <label className="text-[16px] leading-5 text-black700 font-bold  ">Ponovljena lozinka</label>
                        <div className=" border border-black200 rounded-[4px] h-[48px] w-full px-3 flex flex-row items-center ">
                            <input
                                className="text-[16px] leading-[22px] text-black700  w-full outline-none  placeholder:text-black200 "
                                placeholder="Ponovljena lozinka"
                                type={showPassword ? 'text' : 'password'}
                                {...register('repeatPassword', {
                                    validate: {
                                        obavezno: (value) => value.length > 0,
                                        najduze: (value) => value.length > 2,
                                        corect: (val: string) => getValues('password') === val,
                                    },
                                })}
                                autoComplete="off"
                            />
                            <div className="cursor-pointer" onClick={toggleShowPassword}>
                                {!showPassword ? <ShowPasswordIcon /> : <HidePasswordIcon width={22} height={18} />}
                            </div>
                        </div>
                        <span className="text-redError text-[12px] leading-5 h-5 ">
                            {errors.repeatPassword?.type === 'obavezno' ? 'Obavezno popunite ovo polje!' : ''}
                            {errors.repeatPassword?.type === 'corect' ? 'Lozinke se ne slažu molim Vas proverite.' : ''}
                            {errors.repeatPassword?.type === 'najduze' ? 'Šifra treba da ima najmanje 3 karaktera!' : ''}
                        </span>
                    </div>

                    <p className="text-redError text-[12px] leading-5 h-5 ">{!!errorMessage ? errorMessage : ''}</p>
                    <div className="w-full flex flex-row gap-4 mb-5">
                        <button
                            className={`w-[40%]  h-[48px] flex items-center justify-center gap-3 rounded-[4px]   text-[18px] text-black700 font-bold cursor-pointer`}
                            disabled={loading}
                            onClick={() => setSelectedMode('login')}
                            title="Nazad na login stranicu"
                        >
                            <ChevronLeft />
                            <p>Nazad</p>
                        </button>

                        <button
                            type="submit"
                            className={`flex-1 h-[48px] flex items-center justify-center rounded-[4px]   bg-orange300 hover:bg-orange400  text-[18px] text-black700 font-bold cursor-pointer`}
                            disabled={loading}
                        >
                            {loading ? (
                                <Loading size={25} />
                            ) : (
                                <div className="w-full flex flex-row items-center justify-center gap-3">
                                    <p>Sledeći korak</p>
                                    <ChevronLeft style={{ transform: `rotate(180deg)` }} />
                                </div>
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default Registration;
